module.exports = __webpack_public_path__ + "static/media/slav.05ad11a6.jpg";